// Libellés de catégories de blog localisés (fr/en/ar/it)
const CATEGORY_LABELS = {
  fr: { mariage: 'Mariage', festival: 'Festival', corporate: 'Entreprise', club: 'Club', soiree: 'Soirée', general: 'Général', conseils: 'Conseils', villes: 'Villes' },
  en: { mariage: 'Wedding', festival: 'Festival', corporate: 'Corporate', club: 'Club', soiree: 'Party', general: 'General', conseils: 'Tips', villes: 'Cities' },
  ar: { mariage: 'زفاف', festival: 'مهرجان', corporate: 'شركات', club: 'نادٍ', soiree: 'سهرة', general: 'عام', conseils: 'نصائح', villes: 'مدن' },
  it: { mariage: 'Matrimonio', festival: 'Festival', corporate: 'Aziende', club: 'Club', soiree: 'Festa', general: 'Generale', conseils: 'Consigli', villes: 'Città' },
};

const DATE_LOCALES = { fr: 'fr-FR', en: 'en-US', ar: 'ar-AE', it: 'it-IT' };

export const categoryLabel = (key, lang) => {
  const map = CATEGORY_LABELS[lang] || CATEGORY_LABELS.fr;
  return map[key] || (CATEGORY_LABELS.fr[key] || key);
};

export const formatBlogDate = (dateStr, lang) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString(DATE_LOCALES[lang] || 'fr-FR', {
      year: 'numeric', month: 'long', day: 'numeric',
    });
  } catch (e) {
    return '';
  }
};
